import React, {
  Component,
  useReducer,
  useState,
  useEffect,
  useRef
} from "react";
import { render } from "react-dom";
import MapList from "./MapList";
import { DatasourceContext, ProgressContext } from "./MolstackContexts";
import UglymolViewer from "./UglymolViewer";
import LensIcon from "@material-ui/icons/Lens";
import request from "superagent";
import Datasource from "./Datasource";
import ResidueList from "./ResidueList";
import TabPanel, { TabElement } from "./TabPanel";
import ViewListIcon from "@material-ui/icons/ViewList";
import StarIcon from "@material-ui/icons/Star";
import BlurOnIcon from "@material-ui/icons/BlurOn";
import PointsOfIntrest from "./Poi.js";
import produce, { original } from "immer";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import PoiEditDialog from "./PoiEdit";
import MolstackAppBar from "./MolstackAppBar";
import NotificationSnackbar from "./NotificationSnackbar";
import LinkDrawer from "./LinkDrawer";
import StacksContainer from "./StackContainers";
import checkCompatibility from "./CompatCheck";

import { flatMap } from "lodash";

import * as Stack from "./Stack";

function ProgressStatus(props) {
  return (
    <div>
      Models loaded: {props.models_loaded} of {props.models_total}
      <br />
      Maps loaded: {props.maps_loaded} of {props.maps_total}
    </div>
  );
}

// function countLoaded(state, action) {
//   if (action.step == 'LOAD' && action.status == 'SUCCESS') {
//     const loaded = Object.assign({}, state.loaded)
//     const obj = state.elementsByUrl[action.key][0]
//     loaded[obj.type].push(obj.url)
//     return ({
//       ...state,
//       loaded
//     })
//   } else {
//     return state;
//   }
// }

const countLoaded = produce((draft, action) => {
  if (action !== "RESET") {
    if (action.status === "INIT") {
      draft.loaded[action.key] = false;
    } else if (
      (action.step === "FINALIZE" && action.status === "SUCCESS") ||
      (action.status === "CANCELLED" || action.status === "FAILURE")
    ) {
      draft.loaded[action.key] = true;
      //TODO: count errors
    }
    let total = 0;
    let completed = 0;
    Object.values(draft.loaded).forEach(v => {
      total += 1;
      if (v) completed += 1;
    });
    draft.total = total;
    draft.completed = completed;
  } else {
    draft.loaded = {};
    draft.completed = 0;
    draft.total = 0;
  }
});

//TODO: useRef?
let viewer1 = new UglymolViewer();
let viewer2 = new UglymolViewer();

viewer1.tied = [viewer2];
viewer2.tied = [viewer1];

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "stretch",
    flexDirection: "column"
  },
  container: {
    // width:"100%", height:"100%",
    flexGrow: 1,
    display: "flex",
    alignItems: "stretch"
  }
}));

function Molstack(props) {
  const classes = useStyles();

  useEffect(() => {
    request.get(props.projectUrl).then(res => {
      const pois = res.body.pois;
      // Sanitize older resuluts
      if (pois.length > 0 && pois[0].order == null) {
        // Sort by id and assign idx to order
        pois.sort((a, b) => {
          if (a.id > b.id) return 1;
          if (a.id < b.id) return -1;
          return 0;
        });
        
        pois.forEach((poi, idx) => {
          poi.order = idx;
        })
      } else {
        // Just sort by order
        pois.sort((a, b) => a.order - b.order)
      }

      
      // Translate stacks
      const stacks = res.body.stacks.map(stack => ({
        id: stack.id,
        name: stack.name,
        elements: flatMap(stack.files, f => {
          if (f.type === "mtz") {
            return f.maps.map(m => Stack.elementFromStackFile(m));
          } else {
            return Stack.elementFromStackFile(f);
          }
        })
      }));
      setPois(pois);
      if (pois) changeView(pois[0]);
      setStacks(stacks);
      setInfo({ title: res.body.name, description: res.body.description });
      setCurrentStack1(stacks[0] && stacks[0].id);
      setCurrentStack2(stacks[1] ? stacks[1].id : stacks[0] && stacks[0].id);
      setOrgStacks(stacks);
      setOrgPois(pois);
    });

    request.get(props.residueDataUrl).then(res => {
      const residues = res.body;
      setResidues(residues);
    });
  }, []);
  // const elementsByUrl = chain(org_stacks)
  //   .flatMap((s) => s.elements).uniqBy('url').groupBy('url')
  //   .value();
  //
  // const elementsByType = chain(org_stacks)
  //   .flatMap((s) => s.elements).uniqBy('url').groupBy('type')
  //   .value();
  //
  // const [state, dispatch] = useReducer(
  //   countLoaded, {
  //     elementsByUrl: {},
  //     elementsByType: {},
  //     loaded: {'map':[], 'pdb':[]},
  //   }
  // )
  const [loaded1, progress1] = useReducer(countLoaded, {
    loaded: {},
    total: 0,
    completed: 0
  });

  const [loaded2, progress2] = useReducer(countLoaded, {
    loaded: {},
    total: 0,
    completed: 0
  });

  const [view, setView] = useState(null);
  const [stacks, setStacks] = useState([]);
  const [orgStacks, setOrgStacks] = useState([]);
  const [pois, setPois] = useState([]);
  const [orgPois, setOrgPois] = useState([]);
  const [editPoi, setEditPoi] = useState({ open: false });
  const [currentStack1, setCurrentStack1] = useState(null);
  const [currentStack2, setCurrentStack2] = useState(null);
  const [residues, setResidues] = useState([]);
  const [info, setInfo] = useState({});
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [edit, setEdit] = useState(props.edit);
  const [viewType, setViewType] = useState("split");
  // const [viewOrientation, setViewOrientation] = useState('horizontal');
  const [viewOrientation, setViewOrientation] = useState("horizontal");

  //TODO: clear, its to long to be here
  const rmsdChange = useRef(0);
  const rmsdDebounce = useRef();

  const changeRMSD = e => {
    e.preventDefault();
    //Debounce and accumulate
    rmsdChange.current += e.deltaY > 0 ? -0.1 : 0.1;
    clearTimeout(rmsdDebounce.current);
    rmsdDebounce.current = setTimeout(() => {
      const rmsd_change = rmsdChange.current;
      rmsdChange.current = 0;
      setStacks(
        produce(draft => {
          draft.forEach(s => {
            s.elements.forEach(e => {
              if (e.type === "map" && !e.options.locked) {
                let _rmsd = e.options._rmsd;
                _rmsd = _rmsd || _rmsd == 0 ? _rmsd : e.options.rmsd;
                _rmsd = Math.round((_rmsd + rmsd_change) * 10) / 10;
                e.options.rmsd = _rmsd > 0.1 ? _rmsd : 0.1;
                e.options._rmsd = _rmsd;
              }
            });
          });
        })
      );
    }, 100);
  };

  const changeView = v => {
    setView(view => {
      if (v === null) {
        return { mode: "reset" };
      } else {
        // always use new view, to reset it if changed manually
        return { ...view, ...v, mode: "update" };
      }
    });
    if (v !== null) {
      setPois(
        produce(draft => {
          draft.forEach(p => {
            if (p.id == v.id) p.selected = true;
            else p.selected = false;
          });
        })
      );
    }
  };

  const changeMapLock = m => {
    setStacks(
      produce(draft => {
        const map = Stack.getById(draft, m.stack_id, m.id);
        map.options.locked = map.options.locked ? false : true;
      })
    );
  };
  const changeMapVisible = m => {
    setStacks(
      produce(draft => {
        const map = Stack.getById(draft, m.stack_id, m.id);
        map.options.hidden = map.options.hidden ? false : true;
      })
    );
  };

  const resetRMSD = m => {
    setStacks(
      produce(draft => {
        const map = Stack.getById(draft, m.stack_id, m.id);
        const org_map = Stack.getById(orgStacks, m.stack_id, m.id);
        map.options.rmsd = org_map.options.rmsd;
        map.options._rmsd = org_map.options.rmsd;
      })
    );
  };

  const changePoi = data => {
    setPois(
      produce(draft => {
        const poi_id = data.id;
        let poi;
        if (poi_id !== null && poi_id !== undefined) {
          poi = draft.find(p => p.id === poi_id);
        } else {
          //Add new
          const localView = viewer1.getView();
          poi = {
            id: Math.max(...draft.map(e => e.id), -1) + 1,
            xyz: localView.xyz,
            eye: localView.eye,
            zoom: localView.zoom,
            order: Math.max(...draft.map(e => e.order), -1) + 1
          };
          draft.push(poi);
        }
        poi.title = data.title;
        poi.description = data.description;
      })
    );
    setEditPoi({ close: true });
  };

  const reorderPoi = (poi_id, change) => {
    //FIXME: Curently change can be onnly +1/-1
    setPois(
      produce(draft => {
        const poi1_idx = draft.findIndex(p => p.id === poi_id);
        const poi1 = draft[poi1_idx]
        const poi2_idx = draft.findIndex(p => p.order === (poi1.order + change ));
        const poi2 = draft[poi2_idx]
        
        poi1.order = poi1.order + change;
        poi2.order = poi2.order - change;
        // Swap elements
        [draft[poi1_idx], draft[poi2_idx]] = [poi2, poi1]
    })
    )
  }
  
  const removePoi = poi_id => {
    setPois(
      produce(draft => {
        draft.splice(draft.findIndex(p => p.id === poi_id), 1);
      })
    );
  };

  const savePoi = () => {
    //TODO: move to datasource etc.
    request
      .post(props.submitUrl)
      .set("Content-Type", "application/json")
      .set("X-CSRFToken", props.csrfToken)
      .send({ pois: pois })
      .end((error, result) => {
        if (error) {
          setError("Unable to save data (" + error + ")");
          return;
        } else {
          setMessage("Succesfully saved data");
        }
      });
  };

  const closeEditPoi = () => {
    setEditPoi(
      produce(draft => {
        draft.open = false;
      })
    );
  };

  const selectPoiForEdit = id => {
    const poi = pois.find(p => p.id === id);
    setEditPoi({
      ...poi,
      open: true
    });
  };

  const changeViewType = type => {
    //Store current view from first viewer
    const localView = viewer1.getView();
    setViewType(type);
    setView(localView);
  };

  const resetPois = () => {
    setPois(orgPois);
  };

  const residue_groups_labels = {};
  Stack.groupStacksByModelId(stacks).forEach((v, k) => {
    residue_groups_labels[k] = `${v.label || ""} from stacks: ${v.stacks.join(
      ", "
    )}`;
  });

  const stack1 = stacks.find(s => s.id === currentStack1);
  const stack2 = stacks.find(s => s.id === currentStack2);

  const completed1 = stack1 ? (loaded1.completed / loaded1.total) * 100 : 0;
  const completed2 = stack2 ? (loaded2.completed / loaded2.total) * 100 : 0;
  // let comleted_both = 0;
  // if (stack1 && stack2) {
  //   completed_both = (loaded1.completed + loaded2.completed)/(loaded1.total + loaded2.total)*100
  // } else if (stack1) {
  //   completed_both = completed1;
  // } else if (stack2) {
  //   completed_both = completed2;
  // }

  // useEffect(() => {
  //   window.addEventListener("wheel", changeRMSD);
  //   return () => window.removeEventListener("wheel", changeRMSD);
  // }, []);

  const viewers = [
    {
      instance: viewer1,
      currentStack: currentStack1,
      onStackChange: id => {
        setCurrentStack1(id), progress1("RESET");
      },
      progress: progress1,
      completed: completed1
    },
    {
      instance: viewer2,
      currentStack: currentStack2,
      onStackChange: id => {
        setCurrentStack2(id), progress2("RESET");
      },
      progress: progress2,
      completed: completed2
    }
  ];

  return (
    <div className={classes.root}>
      <MolstackAppBar
        info={info}
        editable={props.editable}
        edit={edit}
        onEdit={() => setEdit(true)}
        onReset={resetPois}
        onBack={() => {
          window.location = props.backUrl;
        }}
        onSave={savePoi}
        onMenu={() => setDrawerOpen(!drawerOpen)}
        onStackEdit={() => {
          window.location = props.projectEditUrl;
        }}
        viewType={viewType}
        onViewTypeChange={changeViewType}
        features={props.features}
      />
      <NotificationSnackbar
        message={message}
        open={Boolean(message)}
        onClose={() => setMessage(null)}
      />
      <NotificationSnackbar
        message={error}
        open={Boolean(error)}
        onClose={() => setError(null)}
      />
      <LinkDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        links={props.menuLinks}
      />
      <div className={classes.container}>
        <DatasourceContext.Provider value={Datasource}>
          <TabPanel active={0}>
            <TabElement label="Views" icon={<StarIcon />}>
              <PointsOfIntrest
                elements={pois}
                onClick={view => changeView(view)} //this.setIntrest.bind(this)}
                onAdd={selectPoiForEdit}
                editable={props.editable && edit} //this.props.editable}
                onRemove={removePoi} //this.removeIntrest.bind(this)}
                onEdit={selectPoiForEdit} //this.editIntrest.bind(this)}
                onReorder={reorderPoi}
              />
              {editPoi.open && (
                <PoiEditDialog
                  id={editPoi.id}
                  title={editPoi.title}
                  description={editPoi.description}
                  onCancel={closeEditPoi}
                  onSubmit={changePoi}
                />
              )}
            </TabElement>
            <TabElement label="Residues" icon={<ViewListIcon />}>
              <ResidueList
                residues={residues}
                model_labels={residue_groups_labels}
                onRowClick={(e, data) => changeView({ xyz: data.xyz })}
              />
            </TabElement>
            <TabElement label="Maps" icon={<BlurOnIcon />}>
              <MapList
                stacks={stacks}
                onLock={changeMapLock}
                onReset={resetRMSD}
                onHide={changeMapVisible}
              />
            </TabElement>
          </TabPanel>
          <StacksContainer
            type={viewType}
            orientation={viewOrientation}
            onWheel={changeRMSD}
            stacks={stacks}
            view={view}
            viewers={viewers}
          />

          {/*}
      <ProgressStatus
        models_total={state.elementsByType.pdb.length}
        models_loaded={state.loaded.pdb.length}
        maps_total={state.elementsByType.map.length}
        maps_loaded={state.loaded.map.length}
        />
      <div><pre>{JSON.stringify(stacks, null, 1)}</pre></div>
      */}
        </DatasourceContext.Provider>
      </div>
    </div>
  );
}

export default Molstack;
